export const PATH_ENV = "/environments";

export function getEnvironments() {
  return this.http.get(PATH_ENV);
}
